export const projects = {
  // Page titles
  agencyTitle: "Projects",
  tasksTitle: "Tasks",

  // Filters (Projects/Tasks)
  serviceLabel: "Service",
  statusLabel: "Status",
  deadlineLabel: "Deadline",
  clearFilters: "Clear",

  // Projects table headers and texts
  projectNumberHeader: "#Project Number",
  taskNumberHeader: "Task Number",
  projectStatusHeader: "Project Status",
  serviceHeader: "Service",
  totalVolumeHeader: "Total Volume",
  deadlineHeader: "Deadline",
  inProgress: "In progress",
  loadingProjects: "Loading projects...",
  emptyProjects: "You don't have any projects yet",
  uploadDeliverables: "Upload Deliverables",
  viewReferences: "View References",

  // Panels
  referenceFilesTitle: "Reference Files",
  noReferenceFiles: "No reference files",
  deliverablesTitle: "Deliverables",
  uploadFile: "Upload File",
  attachFilesPlaceholder: "Attach file(s)",

  // Also support existing literal keys used in components
  "Reference Files": "Reference Files",
  "No reference files": "No reference files",
  Deliverables: "Deliverables",
  "Upload File": "Upload File",
  "Attach file(s)": "Attach file(s)",
  Confirm: "Confirm",

  searchPlaceholderKey: " Project Number",
  searchTaskPlaceholderKey: " PO Number",

  // Assignee subtable
  poHeader: "#PO",
  fileNameHeader: "File Name",
  downloadFileName: "Download File",
  taskStatusHeader: "Task Status",
  assigneeNameHeader: "Assignee Name",
  batchVolumeHeader: "Batch Volume",
  loadingAssignee: "Loading assignee...",
  acceptPo: "Accept PO",
  rejectPo: "Reject PO",
  viewTaskBrief: "View Task Brief",

  acceptTask: "Accept task",
  rejectTaskTitle: "Reject task",
  // Task Brief Panel
  briefTitle: "Brief",
  taskBriefTitle: "Task Brief",

  // Freelancer tasks
  loadingTasks: "Loading tasks...",
  emptyTasks: "You don't have any tasks yet",
  skill: "Skill",
  workSpace: "Workspace",
};
